// src/constants/formOptions.js
export const topicOptions = [
    "Marketing Strategy", "Brand Building", "Sales Growth", "Customer Retention", "Lead Generation",
    "Social Media Strategy", "SEO Improvement", "Content Marketing", "Pricing Strategy", "Product Development",
    "Business Expansion", "Market Research", "Competitor Analysis", "Digital Transformation", "Technology Upgrade",
    "Employee Training", "Hiring Strategy", "Customer Feedback Strategy", "Product Launch", "Rebranding",
    "User Experience Design", "App or Website Optimization", "Conversion Rate Boost", "Email Marketing Strategy",
    "Community Building", "Influencer Marketing", "Advertising Planning", "Referral Program Design", "Growth Hacking",
    "Operations Streamlining", "Logistics Optimization", "International Expansion", "Remote Team Management",
    "Outsourcing Advice", "Project Planning", "Funding Strategy", "Investor Pitching", "Revenue Diversification",
    "Subscription Model Setup", "Customer Journey Mapping", "Risk Management", "KPI Definition",
    "Product-Market Fit Check", "SaaS Strategy", "Franchise Model Advice", "B2B Outreach", "CRM Implementation",
    "Financial Forecasting", "Business Automation Ideas"
  ];


// ?\
export const industryOptions = [
    // Major Sectors
    "Technology", "Healthcare", "Education", "Finance", "Retail", "E-commerce",
    "Real Estate", "Manufacturing", "Logistics & Supply Chain", "Hospitality",
    "Travel & Tourism", "Media & Entertainment", "Construction", "Agriculture",
    "Automotive", "Energy", "Telecommunications", "Legal", "Marketing",
    "Human Resources", "Consulting",

    // Startups & SMEs
    "Startup", "Small Business", "SME", "Freelancer",

    // Online/Platform-Specific
    "SaaS Company", "Fintech Startup", "Mobile App Startup", "Digital Agency",
    "Online Course Provider", "Tutoring Service", "Affiliate Marketer",
    "Influencer or Creator", "Podcast Business", "Dropshipping Business",

    // Professional Services
    "Accounting Firm", "Law Firm", "HR Consultancy", "Recruitment Agency",
    "IT Services", "BPO or Call Center", "Interior Design Firm",

    // Consumer-Facing Services
    "Restaurant or Café", "Salon or Spa", "Fitness Studio", "Yoga or Wellness Center",
    "Photography Business", "Event Planning", "Courier Service",

    // Institutions
    "Educational Institution", "Healthcare Clinic", "Veterinary Practice",
    "Non-Profit", "Government Agency",

    // Product & Goods
    "Retail Business", "Wholesale", "Furniture Manufacturing", "Handicraft Business",
    "Game Development", "Fashion Brand", "Food & Beverage", "Beauty & Cosmetics",

    // Real Assets
    "Real Estate Agency", "Property Management", "Construction Business",

    // Niche/Local
    "Travel Agency", "Agriculture Business", "Automobile Workshop"
  ];

export const generalAreaOptions = ["AI & ML", "SaaS", "Blockchain", "Cybersecurity", "Cloud Computing"];

export const areaOptionsByIndustry = {
    // Core Sectors
    "Technology": ["Tech Stack Assessment", "Cloud Adoption", "AI Integration", "Cybersecurity Strategy"],
    "Healthcare": ["EMR Implementation", "Telemedicine Strategy", "Patient Engagement", "Billing Compliance"],
    "Education": ["LMS Optimization", "Digital Curriculum", "Parent Engagement", "Assessment Tools"],
    "Finance": ["Financial Forecasting", "Risk Assessment", "KYC Compliance", "Payment Gateway Strategy"],
    "Retail": ["POS Integration", "Inventory Replenishment", "Customer Loyalty", "Store Experience"],
    "E-commerce": ["Product Listing Optimization", "Checkout UX", "Cart Recovery", "Fulfillment Automation"],
    "Real Estate": ["Lead Management", "CRM Integration", "3D Tours", "Broker Collaboration"],
    "Manufacturing": ["Workflow Automation", "Inventory Forecasting", "Lean Process", "Vendor Management"],
    "Logistics & Supply Chain": ["Fleet Visibility", "Warehouse Automation", "Demand Forecasting", "Last Mile Optimization"],
    "Hospitality": ["Booking Optimization", "Customer Review Management", "Menu Personalization", "Upselling Systems"],
    "Travel & Tourism": ["Package Personalization", "Payment Integrations", "Local Experience Curation", "Itinerary Automation"],
    "Media & Entertainment": ["Content Strategy", "Audience Analytics", "Monetization Models", "Sponsorship Integration"],
    "Construction": ["Project Scheduling", "Safety Compliance", "Material Cost Estimation", "Workforce Allocation"],
    "Agriculture": ["Precision Farming Tools", "Market Linkage", "Crop Cycle Tracking", "Agri-Tech Integration"],
    "Automotive": ["Workshop Scheduling", "Spare Part Sync", "Customer Reminders", "Diagnostics Integration"],
    "Energy": ["Grid Management", "Sustainability Analytics", "Energy Forecasting", "Compliance Reporting"],
    "Telecommunications": ["Billing System Optimization", "Customer Churn Prevention", "Usage Monitoring", "Self-Service Portals"],
    "Legal": ["Case Workflow", "Document Drafting Automation", "Billing Systems", "Legal Research Tools"],
    "Marketing": ["Campaign Automation", "SEO & SEM Strategy", "Influencer ROI", "Content Analytics"],
    "Human Resources": ["Applicant Tracking", "Employee Engagement", "Onboarding Process", "Upskilling Framework"],
    "Consulting": ["Proposal Builder", "Client Briefing Automation", "Knowledge Base", "Use Case Repository"],

    // Startup & Online-first
    "Startup": ["Product-Market Fit", "Pitch Deck Prep", "Fundraising Strategy", "MVP Launch"],
    "Small Business": ["POS Setup", "Local Ads Strategy", "Customer Follow-up", "Cash Flow Tracking"],
    "Freelancer": ["Portfolio Design", "Contract Templates", "Time Tracking", "Client Feedback Collection"],
    "Digital Agency": ["Proposal Automation", "Performance Analytics", "Client Portals", "Creative Workflow"],
    "SaaS Company": ["Trial Conversion Optimization", "Churn Reduction", "Usage Analytics", "API Documentation Strategy"],
    "Fintech Startup": ["Lending Workflow", "KYC Automation", "Compliance Dashboards", "Transaction Insights"],
    "Mobile App Startup": ["App Store Optimization", "Push Notification Strategy", "Session Analytics", "Crash Reporting"],
    "Dropshipping Business": ["Supplier Automation", "Shipping Tracker Integration", "Margin Analysis", "Niche Product Discovery"],
    "Affiliate Marketer": ["SEO & Content Planning", "Commission Analysis", "Referral Tracking", "CTA Optimization"],
    "Influencer or Creator": ["Brand Partnership Planning", "Growth Analytics", "Content Calendar", "Monetization Mapping"],
    "Podcast Business": ["Episode Scheduling", "Audience Metrics", "Sponsorship Kit", "Distribution Strategy"],
    "Online Course Provider": ["Course Engagement Metrics", "Student Feedback Loops", "Upsell Strategy", "Gamification Features"],

    // Services
    "Tutoring Service": ["Session Scheduler", "Progress Reports", "Feedback Collection", "Parent Updates"],
    "Salon or Spa": ["Appointment Management", "Inventory Restock Alerts", "Customer Retention Offers", "Service Personalization"],
    "Fitness Studio": ["Class Booking", "Progress Tracking", "Trainer Scheduling", "Membership Offers"],
    "Yoga or Wellness Center": ["Mindfulness Program Design", "Session Scheduling", "Subscription Packages", "Client Feedback Loop"],
    "Photography Business": ["Client Gallery Workflow", "Print Management", "Session Booking", "Editing Pipeline"],
    "Restaurant or Café": ["Menu Optimization", "Table Booking", "Order Management", "Customer Review System"],
    "Event Planning": ["Task Checklist Automation", "Vendor Sync", "Guest RSVP Tools", "Budget Dashboard"],
    "Healthcare Clinic": ["Appointment Workflow", "EMR Handling", "Billing Automation", "Patient Communication"],
    "Veterinary Practice": ["Pet History Management", "Routine Reminder System", "Prescription Refill Tools", "Owner Education Portals"],
    "Educational Institution": ["Student Analytics", "Exam Automation", "Parent Communication", "Timetable Management"],
    "Courier Service": ["Live Tracking", "Delivery Analytics", "Pickup Automation", "Customer Support Integration"],
    "HR Consultancy": ["Resume Parsing Tools", "ATS System", "Client Reporting", "Hiring Pipeline Dashboard"],
    "Recruitment Agency": ["Candidate Matching", "Talent CRM", "Interview Scheduler", "Job Listing Optimization"],
    "Interior Design Firm": ["Project Visualizer", "Moodboard Tools", "Cost Estimation", "Client Feedback Collector"],
    "Furniture Manufacturing": ["Customization Workflows", "Inventory Visibility", "Order Pipeline", "Supplier Coordination"],
    "Handicraft Business": ["Product Cataloging", "Craft Material Sourcing", "Shipping Partner Sync", "Marketplace Strategy"],
    "Accounting Firm": ["Client Dashboard", "Invoice Generator", "Tax Alerts", "Document Storage"],
    "BPO or Call Center": ["Agent Quality Analytics", "Voice AI Insights", "Shift Management", "Script Optimization"],
    "IT Services": ["Ticket Tracking", "Patch Alerts", "Client Feedback", "Resource Utilization Dashboard"]
  };

export const stateOptions = [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat",
    "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh",
    "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
    "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh",
    "Uttarakhand", "West Bengal"
  ];

export const revenueOptions = [
  "0-10000",
  "10000-50000",
  "50000-100000",
  "100000-500000",
  "500000-1000000",
  "1000000-5000000",
  "5000000-10000000",
];

export const stages = [
  "Idea Stage",
  "Startup",
  "Early Growth",
  "Scaling",
  "Established",
  "Mature Enterprise",
  "Pivot / Reboot",
];
export const categories = ["product", "support", "sales", "marketing"];
